module.exports = __webpack_public_path__ + "static/media/practiseguro_banner.3ec1c62e.png";